import { ID_TYPE } from '@/const/types';

/* state */
export interface UserState {
    token: string;
    expireTime: number; // Unix timestamp
    email: string;
    keepLogin: boolean;
    customerInfo: null | StorageCustomerInfo;
    noticeClosed: boolean;
}

/* local storage */
export interface StorageUserData {
    token: string;
    keepLogin: boolean;
}

export interface StorageCustomerInfo {
    company_no: ID_TYPE;
    customer_no: ID_TYPE;
    customer_id: string;
}

/* http form */
export interface LoginForm {
    email: string;
    password: string;
    keepLogin: boolean;
}

/* result */
export interface ParsedToken {
    access_token: string;
    exp: number;
    user_email: string;
    user_id: number;
    user_name: string;
}


/* ActionError */
export enum ActionError {
    HTTP_LOGIN_RESPONSE = 1,
    HTTP_LOGIN_RESPONSE_NOT_FOUND,
    HTTP_LOGIN_RESPONSE_NOT_MATCHED,
    VUEX_SET_USER,
    VUEX_CLEAR_USER,
    HTTP_REFRESH,
    IS_NOT_LOGIN,
    ERR_GET_CUSTOMER_INFO,
    ERR_SET_CUSTOMER_INFO,
}
